"use client";

import { INVITATION_CODE, SECRETS } from "@/app/config";
import { Button } from "@workspace/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@workspace/ui/components/dialog";
import { Input } from "@workspace/ui/components/input";
import { Label } from "@workspace/ui/components/label";
import { signIn } from "next-auth/react";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { AppDisableOverlay } from "@/components/AppDisableOverlay";

export function ZitadelSignUpButton() {
  const t = useTranslations("Login");
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const [inviteCode, setInviteCode] = useState("");
  const [inviteError, setInviteError] = useState("");

  const handleSignUp = async () => {
    // Check if the invite code is correct
    if (inviteCode === INVITATION_CODE) {
      setInviteDialogOpen(false);
      setRedirecting(true);
      await signIn("zitadel", undefined, {
        scope: [SECRETS.ZITADEL_ORG_SCOPE].join(","),
        prompt: "create",
      });
    } else {
      setInviteError(t("invalidInvitationCode"));
    }
  };

  return (
    <>
      <AppDisableOverlay visible={redirecting} />
      <Button
        variant="secondary"
        size="sm"
        className="w-full text-xs"
        onClick={() => setInviteDialogOpen(true)}
        type="button"
      >
        {t("createNewUser")}
      </Button>

      <Dialog open={inviteDialogOpen} onOpenChange={setInviteDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t("invitationRequired")}</DialogTitle>
            <DialogDescription>{t("invitationDescription")}</DialogDescription>
          </DialogHeader>

          <form onSubmit={(e) => {
            e.preventDefault();
            handleSignUp();
          }}>
            <div className="grid gap-4 py-4">
              <div className="grid gap-2">
                <Label htmlFor="inviteCode">{t("invitationCode")}</Label>
                <Input
                  id="inviteCode"
                  value={inviteCode}
                  onChange={(e) => setInviteCode(e.target.value)}
                  placeholder={t("invitationPlaceholder")}
                />
                {inviteError && <p className="text-sm text-red-500">{inviteError}</p>}
              </div>
            </div>

            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setInviteDialogOpen(false)}>
                {t("cancel")}
              </Button>
              <Button type="submit">{t("continue")}</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
